import { createReducer } from 'ha/myredux/createReducer';
import { STATE_NAME, Actions, ScreenSize } from '../constants';

export const initialState = {
  isMobile: false,
  isIos: false,
  iosVersion: NaN,
  mobileNav: false,
  mediaQueryBreakpoints: {
    [ScreenSize.XS]: false,
    [ScreenSize.SM]: false,
    [ScreenSize.MD]: false,
    [ScreenSize.LG]: false,
    [ScreenSize.XL]: false,
  },
};

export default createReducer(
  {
    [Actions.DISPLAY_MOBILE_NAV]: atom => ({ ...atom, mobileNav: true }),
    [Actions.HIDE_MOBILE_NAV]: atom => ({ ...atom, mobileNav: false }),
    [Actions.SET_MEDIA_BREAKPOINTS]: (state, payload) => ({
      ...state,
      mediaQueryBreakpoints: {
        ...state.mediaQueryBreakpoints,
        ...payload,
      },
    }),
    [Actions.SET_DEVICE]: (state, { mobile, tablet, isIos, iosVersion }) => {
      const isMobile = !!mobile;
      const isTablet = !!tablet;
      const isDesktop = !isMobile && !isTablet;

      return {
        ...state,
        isMobile,
        isIos,
        iosVersion,
        mediaQueryBreakpoints: {
          ...state.mediaQueryBreakpoints,
          xs: isMobile || isTablet || isDesktop,
          sm: isTablet || isDesktop,
          md: isDesktop,
          lg: isDesktop,
        },
      };
    },
  },
  initialState,
);

export const getUI = state => state[STATE_NAME];
export const getIsMobile = state => getUI(state).isMobile;
export const getIsIos = state => getUI(state).isIos;
export const getIosVersion = state => getUI(state).iosVersion;
export const getMediaQueryBreakpoints = state =>
  getUI(state).mediaQueryBreakpoints;
export const isMobileNavActive = state => getUI(state).mobileNav;
